import React from "react";

import Docs from "./docs/Docs";

function App() {
  return (
    <>
      <Docs />
    </>
  );
}

export default App;
